import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import InfoTileContainer from "../../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../../shared-elements/info-tile/info-tile.component";
import { getAssetByCode } from "../../../../../../store/slices/asset.slice";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";

const LightProfileComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;

  const assetDetails = useSelector((state: any) => {
    return state.asset.assetDetails;
  });

  const isLoadingAssetDetails = useSelector((state: any) => {
    return state.asset.isLoadingAssetDetails;
  });

  useEffect(() => {
    if (!id || Object.keys(assetDetails).length) return;
    dispatch(getAssetByCode({ id }));
  }, [id]);

  return (
    <div>
      <div className="asset-details">
        <InfoTileContainer header="Asset Details">
          <InfoTileComponent
            title="Asset ID"
            value={assetDetails?.assetId}
            valueWidth={4}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Display Name"
            value={assetDetails?.sensorDisplayName}
            valueWidth={4}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Asset Type"
            value={assetDetails?.assetType}
            isLoading={isLoadingAssetDetails}
          />
        </InfoTileContainer>

        <InfoTileContainer header="Location Details">
          <InfoTileComponent
            title="Town Council"
            value={assetDetails?.townCouncil}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Address"
            value={assetDetails?.address}
            isLoading={isLoadingAssetDetails}
          />
          <InfoTileComponent
            title="Level"
            value={assetDetails?.floor}
            isLoading={isLoadingAssetDetails}
          />
        </InfoTileContainer>
      </div>
      <div className="mt-3">
        <Outlet />
      </div>
    </div>
  );
};

export default LightProfileComponent;
